import BaseFormatter from './base'
import { hasFields } from '../../helpers'

/**
 * Format report response data for MS Office file details page
 */
export default class EmlDetailsFormatter extends BaseFormatter {
  /**
   * Format original report data
   *
   * @param data
   * @param report
   */
  format(data: { [key: string]: any }, report: { [key: string]: any }): void {
    const result: { [key: string]: any } = {}

    const resource = this.getResource(data, 'file')
    if (!resource) return

    const fileType = !data?.file?.type || data.file.type === 'other' ? this.getFileType(resource) : data.file.type
    if (fileType !== 'eml') {
      return
    }

    this.groupOverview(resource, result)

    if (hasFields(result)) {
      report.eml_details = result
      report.eml_details.overview = { ...report.details.overview, ...report.eml_details.overview }
      delete report.details
    }
  }

  /**
   * Gather data to display in overview block
   *
   * @param data
   * @param result
   */
  groupOverview(resource: { [key: string]: any }, result: { [key: string]: any }): void {
    const overview: { [key: string]: any } = {}
    const metaNames = ['Subject', 'From', 'To', 'Date']
    const meta: any = {}

    if (resource.metaData) {
      for (const key in resource.metaData) {
        if (metaNames.includes(key)) {
          overview[key] = resource.metaData[key]
        } else {
          meta[key] = resource.metaData[key]
        }
      }
    }

    if (hasFields(overview)) {
      result.overview = overview
    }

    if (hasFields(meta)) {
      result.meta = meta
    }
  }
}
